import React from 'react'

import * as S from './styles'

const Tooltip = ({
  continuous,
  isLastStep,
  step,
  primaryProps,
  tooltipProps,
}) => {
  return (
    <S.TooltipBody {...tooltipProps}>
      {step.title && <S.TooltipTitle>{step.title}</S.TooltipTitle>}
      {step.content && <S.TooltipContent data-cy='joyride-content'>{step.content}</S.TooltipContent>}
      <S.TooltipFooter>
        {!isLastStep && continuous && (
          <S.Button data-cy='joyride-next-step' {...primaryProps} title='Próximo'>
            Próximo
          </S.Button>
        )}
        {isLastStep && (
          <S.Button data-cy='joyride-finish' {...primaryProps} title='Entendi'>
            Entendi
          </S.Button>
        )}
      </S.TooltipFooter>
    </S.TooltipBody>
  )
}

export default Tooltip